import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../context/context";
import {
  editIcmsValues,
  getIcmsStatesByCompanyId,
} from "../../../services/icms-service";

export default function Icms() {
  const [selectValue, setSelectValue] = useState("");
  const [spToMg, setSpToMg] = useState({});
  const [mgToGo, setMgToGo] = useState({});
  const [showInputs, setShowInputs] = useState(false);
  const { sidebar } = useContext(Context);
  const accessToken = localStorage.getItem("token");

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      await editIcmsValues(accessToken, spToMg);
      await editIcmsValues(accessToken, mgToGo);
      alert("Icms atualizado com sucesso.");
    } catch (error) {
      alert("Algo deu errado. Tente novamente mais tarde.");
    }
  }

  useEffect(() => {
    async function getIcms() {
      if (selectValue) {
        const result = await getIcmsStatesByCompanyId(accessToken);
        const filteredIcms = result.filter(
          (item) => item.produto_id === selectValue
        );
        setSpToMg(filteredIcms.find((i) => i.ufpartida_id === 26));
        setMgToGo(filteredIcms.find((i) => i.ufpartida_id === 11));
        setShowInputs(true);
      }
    }

    getIcms();
  }, [selectValue]);

  return (
    <>
      <main className={sidebar ? "container" : "container-full"}>
        <h1>Cadastro de Icms</h1>

        <form className="form-container margin-container">
          <FormControl>
            <InputLabel id="demo-simple-select-autowidth-label">
              Selecione o produto
            </InputLabel>
            <Select
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              value={selectValue}
              onChange={(e) => setSelectValue(e.target.value)}
              autoWidth
              label="Selecione o produto"
            >
              <MenuItem value={1}>s10 adt</MenuItem>
              <MenuItem value={2}>s500 adt</MenuItem>
              <MenuItem value={3}>arla granel</MenuItem>
            </Select>
          </FormControl>

          {selectValue && showInputs && (
            <>
              <TextField
                label="Partida: SP / Entrega: MG"
                name="km_cost"
                value={spToMg.price}
                type="number"
                onChange={(e) => {
                  setSpToMg((prevState) => ({
                    ...prevState,
                    price: +e.target.value,
                  }));
                }}
                autoComplete="off"
                inputProps={{
                  autoComplete: "off",
                  step: "0.0001",
                }}
              />
              <TextField
                label="Partida: MG / Entrega: GO"
                name="km_cost"
                value={mgToGo.price}
                type="number"
                onChange={(e) => {
                  setMgToGo((prevState) => ({
                    ...prevState,
                    price: +e.target.value,
                  }));
                }}
                autoComplete="off"
                inputProps={{
                  autoComplete: "off",
                  step: "0.0001",
                }}
              />
              <Button type="submit" onClick={handleSubmit} variant="contained">
                Atualizar
              </Button>
            </>
          )}
        </form>
      </main>
    </>
  );
}
